export default "__VITE_ASSET__CsrqR0WG__"